import React, {useCallback, useEffect, useState} from 'react'
import {Grid,Box} from "@mui/material";
import {useDispatch} from "react-redux";
import {fetchThemes, setSelectedThemes, updateThemes, setActiveTheme} from '../index';
import {Sidebar} from "./Cards/Sidebar";
import {PreviewTab} from "./Tabs/PreviewTab";
import {useParams} from "react-router-dom";
import {Toolbar} from "./Cards/Toolbar";
import {Breadcrumbs} from "../../../../Components";
import {setModal, setTheme} from "../../../Common/App";
import {CloneThemeModal} from "./Modals/CloneThemeModal";

export const View = () => {

    useParams(); // id available from route if needed
    const dispatch = useDispatch();
    const [tab, setTab] = useState(0);
    const [isLoading, setIsLoading] = useState(false);

    const fetchData = useCallback(async () => {
        await fetchThemes({dispatch, filters:{paginate:false,}}).then((res) => {
            setIsLoading(false);
            
            // Auto-select first theme if none selected and themes are available
            if (res.success && res.data && res.data.length > 0) {
                const activeTheme = res.data.find(theme => theme.is_active) || res.data[0];
                dispatch(setSelectedThemes(activeTheme.id));
                dispatch(setActiveTheme(activeTheme));
            }
        });
    }, [dispatch]);

    useEffect(() => {
        fetchData()
    }, [fetchData]);

    const handleClone = (theme) => {
        dispatch(setModal({
            component: <CloneThemeModal 
                theme={theme} 
                onClose={() => fetchData()} 
            />,
            open: true
        }));
    };

    const handleActivate = async (theme) => {
        setIsLoading(true);
        try {
            // Update the selected theme to be active
            await updateThemes({dispatch, data: {id: theme.id, is_active: true}});
            
            // Update the app theme in Redux store
            dispatch(setTheme(theme.properties || {}));
            
            // Set as active theme
            dispatch(setActiveTheme(theme));
            
            // Refresh the themes list to update the UI
            await fetchData();
        } catch (error) {
        } finally {
            setIsLoading(false);
        }
    };


    const renderTabContent = () => {
        switch (tab) {
            case 0:
                return <PreviewTab isLoading={isLoading} setIsLoading={setIsLoading} />;
            default:
                return null;
        }
    };

    return (
        <Grid container spacing={3}>
            <Grid item xs={12}>
                <Box justifyContent={"space-between"} display={"flex"}>
                    <Breadcrumbs items={['DASHBOARD','THEMES']} />
                </Box>
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={4} xl={3}>
                <Sidebar isLoading={isLoading} setIsLoading={setIsLoading}/>
            </Grid>
            <Grid item xs={12} sm={6} md={8} lg={8} xl={9}>
                    <Toolbar tab={tab} setTab={setTab} onClone={handleClone} onActivate={handleActivate} />
                {renderTabContent()}
            </Grid>
        </Grid>
    );
}
